/* esm.sh - @nostrify/nostrify@0.52.0/dist/utils/N64 */
export * from "/*@nostrify/nostrify@0.52.0/esnext/dist/utils/N64.mjs";
